import React, { Component } from "react";
import { Button } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
class SoFileModal extends Component {
    constructor() {
        super();
        this.state = {
            soFile: [],
        }
    }

    handleChangeFile = (file) => {
        this.setState({
            soFile: file,
        })
    }

    handleImportSO = () => {
        const formData = new FormData();
        formData.append('file', this.state.soFile[0]);
        formData.append('company_id', (this.props.selectedCompany || { value: 1 }).value);
        formData.append('warehouse_id', (this.props.selectedWarehouse || { value: 1 }).value);
        this.props.upload(formData, () => {
            this.setState({ soFile: [] })
            this.props.close();
            this.props.refresh();
        }, (err) => {
            this.setState({ soFile: [] })
            this.refs.soFileRef.value = '';
            alert(JSON.stringify(err.data || err));
        })
    }

    render() {
        return <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ fontSize: '14px', fontWeight: 'bold', color: 'orange' }}>
                Please select so file to import.
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <input
                    type='file'
                    ref={'soFileRef'}
                    onChange={(e) => {
                        this.handleChangeFile(e.target.files);
                    }}
                />
                <Button
                    bsStyle="success"
                    disabled={this.state.soFile.length == 0}
                    onClick={() => {
                        this.handleImportSO();
                    }}
                >
                    <em className="fa fa-upload" />
                    <Translate value="upload" />
                </Button>
                <Button
                    bsStyle="primary"
                    style={{ marginLeft: '5px' }}
                    href={'https://scmteambucket.s3.us-west-1.amazonaws.com/attrackpower/SO_IMPORT.xlsx'}
                >
                    <em className="fa fa-download" />
                    <Translate value="download" />
                </Button>
            </div>
        </div>
    }
}

export default SoFileModal;


// WEBPACK FOOTER //
// ./master/jsx/components/Sales/SoFileModal.jsx